attachEvent('.modal__close', 'click', () => {
  document.body.classList.remove('is-open-modal');
});
